export default __webpack_public_path__ + "static/media/lanceofmitra.12c68eb0.png";